import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { UserRole, userSchema } from '../types';

export type EditUserMutationParams = {
	id: number;
	name: string;
	note?: string;
	password?: string;
	hasMultiLogin: boolean;
	role: UserRole;
};

export const createEditUserMutation = () =>
	createAuthMutation({
		params: declareParams<EditUserMutationParams>(),
		request: {
			method: 'PATCH',
			url: ({ id }) => `/user/${id}`,
			body: ({ id, ...params }) => params,
		},
		response: {
			contract: zodContract(userSchema),
		},
	});

export const editUserMutation = createEditUserMutation();
